import $ from 'cash-dom';
import { debounce } from '../utilities/toolkit';
import { searchProducts } from '../resources/shopify-search';
import { searchItem } from '../templates/search-item';

class SearchPanel {
	constructor() {
		this.panel = $('#search-modal');

		this.searchResults = this.panel.find('[data-element="search-results"]');
		this.lastSearch = '';

		this.bindUI();
	}

	bindUI() {
		let me = this;

		$('[data-element="search-input"]').on(
			'keyup',
			debounce(function (e) {
				e.preventDefault();

				if (e.key == 'Escape') {
					me.hide();
					return;
				}

				let query = e.target.value.trim().replace('’', "'");
				if (query == me.lastSearch) return;

				me.lastSearch = query;

				if (query.length == 0) {
					me.hideResults();
					return;
				}
				me.submitSearch(query);
			}, 350)
		);
	}

	showResults(results) {
		let html = '';
		if (results.length > 0) {
			for (let item of results) {
				html += searchItem(item);
			}
		} else {
			html = `<p>no results found</p>`;
		}
		this.searchResults.html(html);
	}

	hideResults() {
		this.searchResults.html('');
	}

	submitSearch(query) {
		let me = this;

		searchProducts(query).then(function (suggestions) {
			const productSuggestions = suggestions.resources.results.products;

			me.showResults(productSuggestions);
		});
	}
}

const searchPanel = new SearchPanel();

export { searchPanel };
